import React           from 'react';
import PropTypes       from 'prop-types';
import Language        from './Language';
import { generateKey } from '../../../../../utils/CommonUtils';

const Languages = (props) => {
    if (!props.spokenLanguages || props.spokenLanguages.length === 0) {
        return null;
    }

    return <ul className={'actor-plate__lang-wrapper' + (props.forceMobile ? ' actor-plate__lang-wrapper--force-mobile' : '')}>
        {props.spokenLanguages && props.spokenLanguages.map((lang) => <Language  key={generateKey(props.name, lang)}  name={props.name + "-" + lang} language={lang}  />)}
    </ul>;
};

Languages.propTypes = {
    spokenLanguages: PropTypes.array,
    name:            PropTypes.string,
    forceMobile:     PropTypes.bool,
};


export default Languages;
